module.exports = __webpack_public_path__ + "media/images/pages/about_vid_poster-a236abb46d2b7fdfada1fbc0f8af85ef.jpg";